
import SpinnerIcon from '@/components/icons/spinner';

/**
 * Button component
 * @deprecated Use ui-kit/components/button instead
 */
export default {
  name: 'ButtonComponent',
  components: {
    SpinnerIcon,
  },
  props: {
    type: {
      type: String,
      default: 'button',
    },
    isSecondary: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    hasSpinner: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    /**
       * Emit click event so it can be used by parent home.
       *
       * @private
       */
    handleClick() {
      this.$emit('click');
    },
  },
};
